/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CloudResourceAttachmentEvent } from '../models/CloudResourceAttachmentEvent';

export class ListResourceAttachmentEventsResponse {
  'events': Array<CloudResourceAttachmentEvent>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "events",
      "baseName": "events",
      "type": "Array<CloudResourceAttachmentEvent>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListResourceAttachmentEventsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

